import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { products } from "@/mocks/homeData";

export default function ProductsPage() {
  return (
    <main className="min-h-screen bg-[#0d0d0d]">
      <Navbar />

      {/* Hero */}
      <section className="relative w-full min-h-[50vh] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20software%20product%20showcase%20with%20multiple%20dashboard%20interfaces%20displayed%20on%20screens%2C%20dark%20tech%20environment%20with%20warm%20amber%20accent%20lighting%2C%20professional%20product%20photography%2C%20futuristic%20digital%20workspace%2C%20clean%20minimal%20design%2C%20moody%20dark%20atmosphere&width=1400&height=700&seq=802&orientation=landscape"
            alt="Trevionix Products"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-[#0d0d0d]/60 to-[#0d0d0d]/30" />
        </div>
        <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pb-16 md:pb-24">
          <p
            className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            / Our Products
          </p>
          <h1
            className="text-4xl md:text-5xl lg:text-[64px] font-extrabold text-white leading-[1.04] tracking-[-0.025em] max-w-2xl"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Software Built
            <br />
            <span className="text-[#6C7278] font-light">for Impact</span>
          </h1>
        </div>
      </section>

      {/* Intro */}
      <section className="w-full px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="max-w-3xl">
          <p
            className="text-base md:text-lg text-white/55 leading-relaxed"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            At Trevionix, we develop proprietary software platforms and custom solutions for businesses across industries. Each product is built with enterprise-grade reliability, intuitive user experience, and the flexibility to scale with your business.
          </p>
        </div>
      </section>

      {/* Product Grid */}
      <section className="w-full px-6 md:px-10 lg:px-16 pb-20 md:pb-28" data-product-shop>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="group bg-[#1A1C1E] border border-white/[0.06] hover:border-white/[0.12] transition-all duration-300 cursor-pointer"
              style={{ borderRadius: "8px" }}
            >
              <div className="relative aspect-[4/5] overflow-hidden" style={{ borderRadius: "8px 8px 0 0" }}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                  loading="lazy"
                />
                {product.badge && (
                  <div
                    className="absolute top-4 left-4 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.1em] bg-[#B8422E] text-white"
                    style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
                  >
                    {product.badge}
                  </div>
                )}
                <div className="absolute inset-0 bg-[#1A1C1E]/0 group-hover:bg-[#1A1C1E]/20 transition-colors duration-500" />
              </div>
              <div className="p-5">
                <p
                  className="text-[10px] uppercase tracking-[0.14em] text-[#6C7278] mb-1"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {product.category}
                </p>
                <h3
                  className="text-sm font-medium text-white"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  {product.name}
                </h3>
                <p
                  className="mt-2 text-base font-bold text-[#B8422E]"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  {product.price}
                </p>
                <button
                  className="mt-4 w-full py-2.5 bg-[#B8422E] text-white text-[12px] font-semibold tracking-[0.08em] hover:bg-[#9E3826] transition-colors"
                  style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
                >
                  Request a Demo
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Custom Development CTA */}
      <section className="w-full px-6 md:px-10 lg:px-16 pb-20 md:pb-28">
        <div className="bg-[#1A1C1E] border border-white/[0.06] p-10 md:p-16 text-center" style={{ borderRadius: "8px" }}>
          <h3
            className="text-2xl md:text-3xl font-extrabold text-white tracking-[-0.02em]"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            Need Something Custom?
          </h3>
          <p
            className="mt-3 text-sm text-[#6C7278] max-w-lg mx-auto"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            We build bespoke software tailored to your exact requirements. From MVPs to enterprise platforms, we deliver.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 mt-6 bg-[#B8422E] text-white px-7 py-3 text-[13px] font-semibold hover:bg-[#9E3826] transition-colors duration-300 whitespace-nowrap"
            style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
          >
            Start a Custom Project
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}